import React from "react";
import KYC from "Pages/KYC";


const KYCtheme = () => {
  return (
    <React.Fragment>
      <KYC />
    </React.Fragment>
  );
};

export default KYCtheme;
